import firebase from 'firebase';
import _ from 'lodash';

import View from '../../../_components/view/view.js';
import newsMgrItemTpl from './news-mgr-item.tpl.html';
import './news-mgr-item.styles.less';

import ConfirmModal from '../../../_modals/confirm-modal/confirm-modal.view.js';

class NewsMgrItem extends View {

	constructor (data, options) {

		super(newsMgrItemTpl, data, _.extend(options, {
				viewClass: 'news-manager-item'
			})
		);
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			btnEdit: '.btn-edit',
			btnDelete: '.btn-delete',
		});
	}

	render(data) {
		super.render(data);
	}

	initializeEvents() {
		this.ui.btnEdit.click(() => this.trigger('edit:new', this.options.__new));
		this.ui.btnDelete.click(() => this.deleteNew());
	}

	deleteNew() {
		new ConfirmModal(
			`¿Estás seguro de que quieres eliminar esta noticia?<br>
				Esta acción <b>NO</b> se puede deshacer
			`,
			'Confirmar borrado'
		).open().then( confirm => {
			if (confirm) {
				this.options.__new.ref.remove();
			}
		});
	}

	/*onShow() {

	}*/


}

export default NewsMgrItem;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/news/item/news-mgr-item.view.js